import { I18n } from 'react-redux-i18n'
import { languages } from '../../../configs/language'
import { isInValidValue } from '../../helpers/value'
import { CURRENCY, UNIT } from '../../utils/currency'

export const calculateMinUnit = ({
  values,
  oldUnit,
  currency,
  exchangeRates,
}) => {
  if (!values || !values.length) return oldUnit

  const min = getMinValueByCurrency({ values, currency, exchangeRates })
  const unit = getMinUnitByCurrency({ min, currency })

  return UNIT[unit].multiplier > UNIT[oldUnit].multiplier ? unit : oldUnit
}

const getMinValueByCurrency = ({ values, currency, exchangeRates }) => {
  const convertValues = values
    .map(({ value, year, exchangeRateType }) => {
      if (isInValidValue(value)) return value
      const availableYears =
        Object.keys(
          exchangeRates?.[currency === CURRENCY.VND ? CURRENCY.USD : currency],
        ) || []
      if (!availableYears.includes(year)) {
        year = availableYears?.[availableYears.length - 1]
      }
      if (
        !exchangeRateType ||
        !['averagerate', 'lastdayrate'].includes(exchangeRateType.toLowerCase())
      ) {
        exchangeRateType = 'averagerate'
      }
      const exchangeRate =
        exchangeRates?.[currency]?.[year]?.[exchangeRateType.toLowerCase()] || 1
      return Math.abs(value / exchangeRate)
    })
    .filter(Boolean)

  return Math.min(...convertValues)
}

const getMinUnitByCurrency = ({ min, currency }) => {
  let unit

  if (currency === CURRENCY.VND) {
    switch (true) {
      case min < 1e6:
        unit = UNIT.SINGLE.unitKey
        break
      case min >= 1e6 && min < 1e9:
        unit = UNIT.MILLION.unitKey
        break
      case min >= 1e9 && min < 1e12:
        unit = UNIT.BILLION.unitKey
        break
      default:
        unit = UNIT.TRILLION.unitKey
        break
    }
  } else {
    switch (true) {
      case min < 100:
        unit = UNIT.SINGLE.unitKey
        break
      case min >= 100 && min < 1000:
        unit = UNIT.HUNDRED.unitKey
        break
      case min >= 1000 && min < 1e6:
        unit = UNIT.THOUSAND.unitKey
        break
      case min >= 1e6 && min < 1e9:
        unit = UNIT.MILLION.unitKey
        break
      default:
        unit = UNIT.BILLION.unitKey
        break
    }
  }

  return unit
}

export const convertExchangeRates = (data = []) => {
  const result = {}

  data.forEach((item) => {
    if (!result[item.currencyCode]) {
      result[item.currencyCode] = {}
    }
    result[item.currencyCode][item.realYear] = {
      ...item,
      averagerate: item.averageRate,
      lastdayrate: item.lastDayRate,
    }
  })

  return result
}

export const getFormatedUnit = (locale, currency, unit) => {
  const unitName = I18n.t(UNIT[unit].name)
  return locale === languages.en
    ? `${currency + (unit === UNIT.SINGLE.unitKey ? '' : ' ' + unitName)}`
    : `${(unit === UNIT.SINGLE.unitKey ? '' : unitName + ' ') + currency}`
}
